import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import ReactSwitch from '@core/react/shared-component/Switch/View';
import { setEasyApply } from '@job-facets/redux/jobsFilterSlice';
import EasyApplyIcon from '@job-facets/Icons/easyApplyIcon';

import { __ } from '@wordpress/i18n';

function EasyApply() {
	const { easy_apply } = useSelector((state) => state.jobsFormInput);

	const [openToggle, setOpenToggle] = useState(
		easy_apply ? Boolean(easy_apply) : false,
	);
	const dispatch = useDispatch();

	useEffect(() => {
		setOpenToggle(easy_apply);
	}, [openToggle]);

	return (
		<ReactSwitch
			SwitchLabel={() => {
				return (
					<div className='d-flex gap-5'>
						<EasyApplyIcon />
						<span className='fs-16 fw-400 text-ui-paragraph'>{__('Easy Apply', 'job')}</span>
					</div>
				);
			}}
			onChange={(state) => {
				dispatch(setEasyApply(state));
			}}
			isChecked={Boolean(easy_apply)}
			rootClassNames={'d-flex justify-content-end mb-15'}
		/>
	);
}

export default EasyApply;
